import clsx from "clsx";

interface ColumnCardProps {
  children: React.ReactNode;
  isSubModel?: boolean;
}

const ColumnCard = ({ children, isSubModel }: ColumnCardProps) => {
  return <div className={clsx(isSubModel ? "py-3" : "py-4")}>{children}</div>;
};

export default ColumnCard;
